import React, { useState, useEffect } from "react";
import MainHeader from "../components/MainHeader";
import Footer from "../components/Footer";
import { elsevierStyleSheetJSfileImport } from "../library/utils";
import { useNavigate } from "react-router-dom";
import leaves from "../library/svg/leaves.svg";
import clip from "../library/svg/clip.svg";
import cancel from "../library/svg/cancel.svg";
import axios from "axios";
import { backendBookartUrl } from "../library/constants";
import ExcelDownloadDemo from "../components/ExcelDownloadDemo";

const InstantOrder = () => {
  const [instantOrderForm, setInstantOrderForm] = useState({
    from: "null",
    to: "null",
    cc: [],
    subject: "",
    attachment: "",
    message: "null",
    checked: false,
  });
  const [auth, setAuth] = useState(false);
  const [ccError, setCCError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    authUser(); // Authenticate User
    getCC();
    elsevierStyleSheetJSfileImport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCC = () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    var config = {
      method: "get",
      url: `${backendBookartUrl}/fetch_mail_address?=`,
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    axios(config)
      .then((response) => {
        let to_address = response.data.products[0].to_address;
        let from_address = response.data.products[0].from_address;
        let cc_address = response.data.products[0].cc_address;
        let message = response.data.products[0].message + "\n" + response.data.products[0].name;
        setInstantOrderForm((prevState) => ({
          ...prevState,
          to: to_address,
          cc: cc_address,
          message: message,
          from: from_address,
        }));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const validateEmail = (emails) => {

    // Regex to validate a single email address
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Split the input string by commas and trim whitespace
    const emailList = emails.split(',').map(email => email.trim());

    // Validate each email in the list
    for (let email of emailList) {
      if (!emailPattern.test(email)) {
        return false;
      }
    }

    return true;
  };

  const changeCC = (event) => {
    const value = event.target.value;
    setInstantOrderForm((prevState) => ({
      ...prevState,
      cc: value,
    }));

    // Validate CC email
    if (value && !validateEmail(value)) {
      setCCError("Please enter a valid email address.");
    } else {
      setCCError("");
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    navigate("/checkout", { state: { instantOrder: instantOrderForm } });
  };

  const handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    setInstantOrderForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFileCancel = () => {
    setInstantOrderForm((prevState) => ({
      ...prevState,
      attachment: null,
    }));
  };

  const handleCheckBox = () => {
    setInstantOrderForm((prevState) => ({
      ...prevState,
      checked: !prevState.checked,
    }));
  };

  const uploadFile = (event) => {
    var ext = event.target.value.match(/\.([^.]+)$/)[1];
    let attachedFile = "";
    switch (ext) {
      case 'xlsx':
      case 'pdf':
        attachedFile = event.target.files[0];
        break;
      default:
        alert('Invalid file format, upload .xlsx/.pdf files.');
        attachedFile = "";
    }
    setInstantOrderForm((prevState) => ({
      ...prevState,
      attachment: attachedFile,
    }));
  };

  const authUser = async () => {
    const token = window.sessionStorage.getItem("JWTtoken");

    if (!token) {
      navigate("/");
      return;
    }

    setAuth(true);
  };

  if (!auth) {
    return <div></div>;
  } else {
    return (
      <React.Fragment>
        <MainHeader />
        <section className="container min-height60">
          <section className="body light-pink">
            <div className="container bulk-heading-container">
              <div className="bulk-heading">
                <h1>Place your Instant Bulk Order</h1>
                <h3>
                  Fill in the details, upload your order and place your bulk
                  order instantly.
                </h3>
              </div>

              <div className="bulk-order-leaves-container">
                <img className="bulk-order-leaves" src={leaves} alt="leaves" />
              </div>
            </div>
          </section>
          <div className="container">
            <form className="instantOrder" onSubmit={handleSubmit}>
              <div className="formGroup">
                <div className="es-input-text small">
                  <input
                    className="border-light-ash"
                    id="from"
                    name="from"
                    value={instantOrderForm.from}
                    placeholder="&nbsp;"
                    readOnly={true}
                    required
                  />
                  <label htmlFor="from">From</label>
                </div>
              </div>
              <div className="formGroup">
                <div className="es-input-text small">
                  <input
                    className="border-light-ash"
                    id="to"
                    name="to"
                    value={instantOrderForm.to}
                    placeholder="&nbsp;"
                    readOnly={true}
                    required
                  />
                  <label htmlFor="to">To</label>
                </div>
              </div>
              <div className="formGroup">
                <div className="es-input-text small">
                  <input
                    className="border-light-ash"
                    id="cc"
                    name="cc"
                    value={instantOrderForm.cc}
                    placeholder="&nbsp;"
                    // onKeyDown={removeCC}
                    onChange={changeCC}
                  />
                  <label htmlFor="cc">CC</label>
                  {ccError && <div className="error-message">{ccError}</div>} {/* Display error message */}
                </div>
              </div>
              <div className="formGroup">
                <div className="es-input-text small">
                  <input
                    className="border-light-ash"
                    id="subject"
                    name="subject"
                    value={instantOrderForm.subject}
                    placeholder="&nbsp;"
                    onChange={handleChange}
                    maxLength="50"
                  />
                  <label htmlFor="subject">
                    Subject (Order number / PO number / Order subject/ Date)
                  </label>
                </div>
              </div>
              <div className="formGroup file-upload-container">
                <div className="es-input-text small">
                  <label htmlFor="attachment" className="color-black font-16">
                    Attachment*{" "}
                    <span className="color-light-ash">
                      {"(supported format .xlsx/pdf, File Size < 20mb)"}
                    </span>
                  </label>
                  <br />
                </div>
                <div className="flex-two">
                  <label className="es-button primary upload-button pointer">
                    &nbsp; Choose File
                    <input
                      type="file"
                      name="attachment"
                      className="collapse"
                      onChange={uploadFile}
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    />
                  </label>
                  <div>
                    <span className="flex-one">
                      Please Download the template <ExcelDownloadDemo />
                    </span>
                  </div>
                </div>
                {instantOrderForm.attachment ? (
                  <label>
                    <img src={clip} alt="clip" />
                    <span className="uploaded-file-name">
                      {instantOrderForm.attachment.name}
                    </span>
                    <img
                      className="pointer"
                      onClick={handleFileCancel}
                      src={cancel}
                      alt="cancel"
                    />
                  </label>
                ) : (
                  <label></label>
                )}
              </div>
              <div className="formGroup">
                <div className="es-input-text small">
                  <label className="color-light-ash">
                    Message for admin (Optional)
                  </label>
                  <br />
                  <textarea
                    className="es-textbox color-more-light-ash"
                    disabled
                    value={instantOrderForm.message}
                  />
                </div>
              </div>
              <div className="formGroup">
                <label className="es-check small">
                  <input
                    className="es-check-input"
                    name="signedIn"
                    checked={instantOrderForm.checked}
                    type="checkbox"
                    onChange={handleCheckBox}
                  />
                  <span>I hereby confirm my order</span>
                </label>
              </div>
              <div className="formGroup">
                <button
                  className="es-button primary medium"
                  type="submit"
                  disabled={
                    typeof instantOrderForm.attachment !==
                    "object" || !instantOrderForm.checked
                  }
                >
                  <span>Confirm Instant order</span>
                  <svg
                    focusable="false"
                    height="24"
                    viewBox="0 0 54 128"
                    width="11"
                  >
                    <path d="M1 99l38-38L1 23l7-7 45 45-45 45z" />
                  </svg>
                </button>
              </div>
            </form>
          </div>
        </section>
        <Footer />
      </React.Fragment>
    );
  }
};

export default InstantOrder;